import {CONSTANTS} from "./meta_data";

export class ImageDataExtremaBerechner {

    imageData: ImageData;
    widthInPixels: number;
    extrema;

    constructor(imageData: ImageData, widthInBytes: number) {
        this.imageData = imageData;
        this.widthInPixels = widthInBytes;
        this.extrema = {minY: 0, minX: 0, maxY: 0, maxX: 0};
    }

    public getExtrema() {
        this.setImageDataMinY();
        this.setImageDataMaxY();
        this.setImageDataMinX();
        this.setImageDataMaxX();
        return this.extrema;
    }

    private setImageDataMinY() {
        let transparencyBitPos;
        const firstPosition = CONSTANTS.TRANSPARENCYBIT_OFFSET;

        for (transparencyBitPos = firstPosition; transparencyBitPos < this.imageData.data.length; transparencyBitPos += CONSTANTS.BYTES_PER_PIXEL) {
            if (this.imageData.data[transparencyBitPos]) {
                this.extrema.minY = this.getYKoordinate(transparencyBitPos);
                return;
            }
        }
    }

    private setImageDataMaxY() {
        let transparencyBitPos;
        for (transparencyBitPos = this.imageData.data.length - 1; transparencyBitPos > 0; transparencyBitPos -= CONSTANTS.BYTES_PER_PIXEL) {
            if (this.imageData.data[transparencyBitPos]) {
                this.extrema.maxY = this.getYKoordinate(transparencyBitPos);
                return;
            }
        }
    }

    private getYKoordinate(transparencyBitPos) {
        return Math.floor((transparencyBitPos - CONSTANTS.TRANSPARENCYBIT_OFFSET) / CONSTANTS.BYTES_PER_PIXEL / this.widthInPixels);
    }

    private setImageDataMinX() {
        let column;
        for (column = 0; column < this.widthInPixels; column++) {
            if (this.columnHasNonEmptyPixel(column)) {
                this.extrema.minX = column;
                return;
            }
        }
    }

    private setImageDataMaxX() {
        let column;
        for (column = this.widthInPixels - 1; column > -1; column--) {
            if (this.columnHasNonEmptyPixel(column)) {
                this.extrema.maxX = column;
                return;
            }
        }
    }

    private columnHasNonEmptyPixel(column) {
        const minY = isNaN(this.extrema.minY) ? 0 : this.extrema.minY,
            maxY = isNaN(this.extrema.maxY) ? 0 : this.extrema.maxY,
            oneLine = this.widthInPixels * CONSTANTS.BYTES_PER_PIXEL,
            pixelNumberInFirstLine = column * CONSTANTS.BYTES_PER_PIXEL + CONSTANTS.TRANSPARENCYBIT_OFFSET,
            pixelPosInLineMinY = pixelNumberInFirstLine + minY * oneLine,
            pixelPosInLineMaxY = pixelNumberInFirstLine + maxY * oneLine;

        let pixelPosInColumn;

        for (pixelPosInColumn = pixelPosInLineMinY; pixelPosInColumn <= pixelPosInLineMaxY; pixelPosInColumn += oneLine) {
            if (this.imageData.data[pixelPosInColumn]) {
                return true;
            }
        }
        return false;
    }
}